var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from "react";
import cn from "classnames";
/**
 * The unstyled button is a really simple button element that resets the default
 * browser button styles into a clear clickable element.
 */

export var UnstyledButton = forwardRef(function UnstyledButton(_a, ref) {
  var className = _a.className,
      children = _a.children,
      props = __rest(_a, ["className", "children"]);

  return React.createElement("button", __assign({}, props, {
    type: "button",
    ref: ref,
    className: cn("rmd-button-unstyled", className)
  }), children);
});

if (process.env.NODE_ENV !== "production") {
  try {
    var PropTypes = require("prop-types");
  } catch (e) {}
}